import { render, staticRenderFns } from "./parentReg.vue?vue&type=template&id=7b1f010a&scoped=true&"
import script from "./parentReg.vue?vue&type=script&lang=js&"
export * from "./parentReg.vue?vue&type=script&lang=js&"
import style0 from "./parentReg.vue?vue&type=style&index=0&id=7b1f010a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1f010a",
  null
  
)

export default component.exports